import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=c392e590&scoped=true"
import script from "./change-password.vue?vue&type=script&lang=ts"
export * from "./change-password.vue?vue&type=script&lang=ts"
import style0 from "./change-password.vue?vue&type=style&index=0&id=c392e590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c392e590",
  null
  
)

export default component.exports